import { render, staticRenderFns } from "./AddressPage.vue?vue&type=template&id=1b6d4f10&scoped=true&"
import script from "./AddressPage.vue?vue&type=script&lang=ts&"
export * from "./AddressPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6d4f10",
  null
  
)

export default component.exports